import * as React from "react";

function SvgCreditCardDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M18 4.25a3.75 3.75 0 013.745 3.55l.005.2v8a3.75 3.75 0 01-3.55 3.745l-.2.005H6a3.75 3.75 0 01-3.745-3.55L2.25 16V8A3.75 3.75 0 015.8 4.255L6 4.25h12zm2.25 5.5H3.75V16a2.25 2.25 0 002.096 2.245L6 18.25h12a2.25 2.25 0 002.245-2.096L20.25 16V9.75zm-10.68 2.5a.75.75 0 01.102 1.493l-.102.007H7a.75.75 0 01-.102-1.493L7 12.25h2.57z"
        />
        <path
          fill="#98DB69"
          d="M18 5.75H6a2.25 2.25 0 00-2.245 2.096L3.75 8v.25h16.5V8a2.25 2.25 0 00-2.096-2.245L18 5.75z"
        />
      </g>
    </svg>
  );
}

export default SvgCreditCardDuo;
